const Define = {
    BG: 'rs-bg-slate-100',
    H_BG: 'hover:rs-bg-slate-200',
    BORDER: 'rs-border rs-border-slate-200',
    ROUND: 'rs-rounded-md'
}

export default Define